module.exports = "I am in age dependent question\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/oldCentralPannel/age-dep/age-dep.component.html
// module id = ./src/app/oldCentralPannel/age-dep/age-dep.component.html
// module chunks = main